module.exports = __webpack_public_path__ + "media/images/admin/icons/info-53089392a49dc3637c527f228efd26d5.svg";